const LIST_PANEL_LOADING_ROW_HEIGHT = 56;

const getListPanelLoadingRowCount = (height: number): number =>
  Math.max(1, Math.ceil(height / LIST_PANEL_LOADING_ROW_HEIGHT));

export { getListPanelLoadingRowCount };
